import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Input } from '../../../../core/design-system/components/Input';
import { Icon } from '../../../../core/design-system/components/Icon';
import PhoneVerificationModal from '../PhoneVerificationModal';
import './styles.css';

export default function PhoneField({ value, onChange, error, disabled }) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    if (!disabled) {
      setIsModalOpen(true);
    }
  };

  const handleVerified = (phoneData) => {
    onChange(phoneData);
    setIsModalOpen(false);
  };

  // S'assurer que nous avons une chaîne valide avant de la parser
  const formattedPhone = value?.phone && typeof value.phone === 'string'
    ? parsePhoneNumberFromString(value.phone)?.formatInternational() || value.phone
    : '';
    
  const isVerified = value?.phoneVerified;

  return (
    <div className="phone-field-wrapper">
      <div className="phone-field-container" onClick={handleClick}>
        <Input
          type="tel"
          value={formattedPhone}
          placeholder={t('settings:phone.placeholder')}
          error={error}
          readOnly
          className="phone-field-input"
        />
        {isVerified && (
          <div className="phone-field-verified" title={t('settings:phone.verified')}>
            <Icon name="check-circle" size={20} />
          </div>
        )}
        <div className="phone-field-overlay" />
      </div>

      <PhoneVerificationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onVerified={handleVerified}
      />
    </div>
  );
} 